import { assertIsError } from '@biteinc/common';
/**
 * @description Similar to async module reflect function except with promises.
 * If the promise throws, then we return the error in an object. If it doesn't
 * then we return the value of the promise in an object.
 */
export async function reflect(promise) {
    try {
        const value = await promise;
        return { value };
    }
    catch (err) {
        assertIsError(err);
        return { err };
    }
}
export async function sleep(milliseconds) {
    return new Promise((resolve) => {
        setTimeout(resolve, Math.max(milliseconds, 0));
    });
}
//# sourceMappingURL=universal_promise_helper.js.map